import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { UserRole } from '../../../domain/users/models/User';

export interface ChatViewVm {
    isReady: boolean;
    isServiceUnavailable: boolean;
    isAdmin: boolean;
    activeUser: {
        displayName: string;
        email: string;
        photoUrl?: string;
    };
}

export const useChatView = (): ChatViewVm => {
    const activeUserInfo = useAppSelector((state) => state.app.activeUserInfo);
    const isServiceUnavailable = useAppSelector((state) => state.app.isServiceUnavailable);

    // TODO: refactor auth: instead of throwing, we need it to refresh token or logout
    if (!activeUserInfo) {
        throw new Error('Active user info was not found.');
    }

    return useMemo(
        () => ({
            isReady: true,
            isServiceUnavailable,
            isAdmin: activeUserInfo.role === UserRole.Admin,
            activeUser: {
                displayName: activeUserInfo.username,
                email: activeUserInfo.email,
                photoUrl: activeUserInfo.photoUrl,
            },
        }),
        [activeUserInfo, isServiceUnavailable],
    );
};

export default useChatView;
